import {UrlStateManagerService} from 'shared/state-manager/url-state-manager.service';
import register from '@kpsys/angularjs-register';


export default register('portaro.shared.state-manager')
    .service(UrlStateManagerService.serviceName, UrlStateManagerService)
    .name()
